import type { CheckoutCartDetail, IdentityScope } from '@branditdev/mf-types'
import { queryOptions } from '@tanstack/react-query'
import branditRails from '../../api/brandit_rails'

const fetchCartDetail = async () => {
  const { data } = await branditRails.get<CheckoutCartDetail>('/cart_detail')
  return data
}

export const cartKeys = {
  all: ['cart'] as const,

  detail: {
    all: ['cart', 'detail'] as const,
    scoped: (scope: IdentityScope) => [...cartKeys.detail.all, scope.identity_key] as const
  },

  preview: {
    all: ['cart', 'preview'] as const,
    scoped: (scope: IdentityScope) => [...cartKeys.preview.all, scope.identity_key] as const
  }
}

type CartDetailQueryOverrides = {
  refetchOnMount?: boolean | 'always'
}

export const cartDetailQueryOptions = (scope: IdentityScope, overrides: CartDetailQueryOverrides = {}) =>
  queryOptions({
    queryKey: cartKeys.detail.scoped(scope),
    queryFn: fetchCartDetail,
    ...overrides
  })
